import { motion } from "framer-motion";
import { WHY_CHOOSE } from "@/data/content";

export default function WhyChooseUs() {
  return (
    <section className="relative py-24 lg:py-32 bg-[#040611]" data-testid="home-why">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="overline">Why Alphatech</div>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
            Built for operators who care about <span className="text-gradient-blue">speed, uptime</span> and margins.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {WHY_CHOOSE.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              data-testid={`why-card-${i}`}
              className="p-6 rounded-2xl bg-[#0B1224]/60 border border-white/[0.06] hover:border-[#2563EB]/30"
              style={{ transition: "border-color 0.3s ease" }}
            >
              <div className="w-11 h-11 rounded-xl bg-white/[0.04] flex items-center justify-center border border-white/10">
                <w.icon className="w-5 h-5 text-[#00D4FF]" />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold">{w.title}</h3>
              <p className="mt-1.5 text-sm text-gray-400 leading-relaxed">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
